import { FilterOption, Pagination } from './types';
import { ProductItem } from '../../types';
import { EventDetailProductItem } from '../../../../../types/query/event/detail';

export const convertToTableData = (data?: EventDetailProductItem[]): ProductItem[] => {
  if (!data) return [];
  return data.map((item) => ({
    id: item.product.id,
    name: item.product.name,
    originPrice: item.product.originPrice,
    salesPrice: item.product.salesPrice,
    discountPeriod:
      item.product.discountStartDate && item.product.discountEndDate
        ? `${item.product.discountStartDate} -\n ${item.product.discountEndDate}`
        : '-',
    createDate: item.product.createDate,
    status: item.product.status,
    discountPrice: item.product.discountPrice,
    discountRate: item.product.discountRate,
    imageUrl: item.productAttachmentList[0].url,
    category: item.productCategoryList.reduce((previousValue, currentValue) => {
      if (previousValue === '') return currentValue.name;
      return `${previousValue}, ${currentValue.name}`;
    }, ''),
    brandId: item.brand.id,
    brandName: item.brand.name,
    eventId: item.id,
  }));
};

export const applyFilterOption = (data: ProductItem[], filterOption: FilterOption) => {
  return data.filter((item) => {
    // 각 조건을 검사하고 필터링 조건이 없거나 일치하면 true를 반환합니다.
    return (
      (!filterOption.name || item.name.match(filterOption.name)) &&
      (!filterOption.brandName || item.brandName.match(filterOption.brandName)) &&
      (!filterOption.id || item.id === Number(filterOption.id)) &&
      (!filterOption.brandId || item.brandId === Number(filterOption.brandId)) &&
      (!filterOption.status || item.status.match(filterOption.status))
    );
  });
};

export const applyPagination = (data: ProductItem[], pagination: Pagination) => {
  return data.slice(pagination.pageNum * pagination.pageSize, (pagination.pageNum + 1) * pagination.pageSize);
};
